import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

// Format date based on site settings format
export const formatDateBySetting = (dateString, format = 'MM/DD/YYYY') => {
  if (!dateString) return '';
  const date = new Date(dateString);
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  switch (format) {
    case 'DD/MM/YYYY':
      return `${day}/${month}/${year}`;
    case 'YYYY-MM-DD':
      return `${year}-${month}-${day}`;
    case 'MM/DD/YYYY':
    default:
      return `${month}/${day}/${year}`;
  }
};

// Format datetime based on site settings format (includes time)
export const formatDateTimeBySetting = (dateString, format = 'MM/DD/YYYY') => {
  if (!dateString) return '';
  const date = new Date(dateString);
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  
  let dateStr;
  switch (format) {
    case 'DD/MM/YYYY':
      dateStr = `${day}/${month}/${year}`;
      break;
    case 'YYYY-MM-DD':
      dateStr = `${year}-${month}-${day}`;
      break;
    case 'MM/DD/YYYY':
    default:
      dateStr = `${month}/${day}/${year}`;
      break;
  }
  
  return `${dateStr} ${hours}:${minutes}`;
};

export const getStatusColor = (status) => {
  const colors = {
    new: 'bg-red-500',
    in_progress: 'bg-yellow-500',
    fixed: 'bg-green-500',
    rejected: 'bg-orange-500',
    closed: 'bg-gray-500'
  };
  return colors[status] || 'bg-gray-500';
};

export const getStatusLabel = (status) => {
  const labels = {
    new: 'New',
    in_progress: 'In Progress',
    fixed: 'Fixed',
    rejected: 'Rejected',
    closed: 'Closed'
  };
  return labels[status] || status;
};

export const getPriorityColor = (priority) => {
  const colors = {
    urgent: 'bg-red-500 text-white',
    high: 'bg-orange-500 text-white',
    medium: 'bg-yellow-500 text-white',
    low: 'bg-green-500 text-white',
  };
  return colors[priority] || 'bg-gray-500 text-white';
};

export const getRoleColor = (roleName) => {
  const colors = {
    'repair_engineer': 'bg-blue-500 text-white',
    'safety_engineer': 'bg-red-500 text-white',
  };
  return colors[roleName] || 'bg-gray-500 text-white';
};

export const getErrorMessage = (error, fallback = 'An error occurred') => {
  if (error.response?.data?.detail) {
    const detail = error.response.data.detail;
    if (typeof detail === 'string') {
      return detail;
    } else if (Array.isArray(detail)) {
      return detail.map(err => err.msg || JSON.stringify(err)).join(', ');
    } else if (typeof detail === 'object') {
      return JSON.stringify(detail);
    }
  }
  return fallback;
};